/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React  from "react";
import { createBrowserHistory } from "history";
import { useClearBrowserCache } from 'react-clear-browser-cache';

import AdminLayout from './layouts/Admin';
import EmptyLayout from './layouts/Empty';
import AuthLayout from "./layouts/Auth";
import 'react-big-calendar/lib/css/react-big-calendar.css';

import 'moment/locale/pt-br';
//Context
import AuthProvider from "context/auth";
import RoutesComponent from "RoutesComponent";

const hist = createBrowserHistory();

export default function App() {
    const contextValue = useClearBrowserCache();
    return (
        <AuthProvider>
            <RoutesComponent/>
        </AuthProvider>
    )
}
